var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Close = function Close(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 11 11' }, props),
    React.createElement(
      'g',
      null,
      React.createElement('path', { d: 'M6.613 5.492l4.27 4.27a.397.397 0 0 1 0 .56l-.56.56a.397.397 0 0 1-.56 0l-4.269-4.27-4.27 4.27a.397.397 0 0 1-.56 0l-.56-.56a.397.397 0 0 1 0-.56l4.27-4.27-4.27-4.269a.397.397 0 0 1 0-.56l.56-.56a.397.397 0 0 1 .56 0l4.27 4.27L9.763.103a.397.397 0 0 1 .56 0l.56.56a.397.397 0 0 1 0 .56l-4.27 4.269z',
        fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

export default Close;
//# sourceMappingURL=Close.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Close.js